import * as React from "react"

export interface ClothesIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number
}

/**
 * Clothes/T-shirt icon for ANYW3AR collection filter
 *
 * This icon represents clothing items in the Trophy Room.
 *
 * @example
 * ```tsx
 * <ClothesIcon />
 * <ClothesIcon size={16} className="text-gray-500" />
 * ```
 */
export const ClothesIcon = React.forwardRef<SVGSVGElement, ClothesIconProps>(
  ({ size = 12, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 20 18.7"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path d="M5.8,1.4c-.2,0-.3,0-.4.2L1.2,6c-.1.1-.2.3-.2.4s0,.3.2.4l2.1,2.2c.1.1.2.2.4.2s.3,0,.4-.2h0s.6-.6.6-.6c.2-.2.4-.2.6-.1.2,0,.3.3.3.5l-.3,7.9c0,.3.2.5.5.5h8.3c.3,0,.5-.2.5-.5l-.3-7.9c0-.2.1-.4.3-.5.2,0,.4,0,.6.1l.6.6c.1.1.2.2.4.2s.3,0,.4-.2l2.1-2.2c.1-.1.2-.3.2-.4s0-.3-.2-.4L14.6,1.6c-.1-.1-.2-.2-.4-.2h-1.5c-.1,0-.3,0-.5.2h0c-.6.6-1.4.9-2.2.9s-1.6-.3-2.2-1h0c-.1-.1-.2-.2-.4-.2h-1.5ZM4.7.8c.3-.3.7-.5,1.1-.5h1.5c.4,0,.9.2,1.1.5.4.5,1,.7,1.5.7s1.1-.2,1.4-.6c.3-.3.7-.6,1.2-.6h1.5c.4,0,.8.2,1.1.5h0s4.2,4.4,4.2,4.4c.3.3.5.7.5,1.2s-.2.9-.5,1.2h0s-2.1,2.2-2.1,2.2c-.3.3-.7.5-1.1.5s-.5,0-.8-.2l.3,6.6s0,0,0,0c0,.9-.7,1.6-1.6,1.6h-8s-.3,0-.3,0c-.9,0-1.6-.7-1.6-1.6s0,0,0,0l.2-6.6c-.2.1-.5.2-.8.2-.4,0-.8-.2-1.1-.5h0S.5,7.6.5,7.6c-.3-.3-.5-.7-.5-1.2s.2-.9.5-1.2h0S4.7.8,4.7.8Z" />
      </svg>
    )
  }
)

ClothesIcon.displayName = "ClothesIcon"
